import { useEffect } from 'react';
import { useDesktopMenuContext } from 'App/components/Menu/DesktopMenuProvider';
import { useTopAdBar } from 'App/components/TopAdBar/useTopAdBar';
import useTopBar from 'App/components/Topbar/useTopBar';
import HelpLink from 'App/HelpLink';
import { useNavegate, useQuery } from 'App/hooks';
import { HeaderContent, HeaderTop, IonPageStratus } from 'commons/components';
import { CanceledStorePage } from 'domains/Account/pages';
import { useStoreChurnedStatus } from 'domains/Billing/hooks';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import { FirstPaymentModal, PlansAndSubscriptionsV2 } from './components';
import { FROM_PAYMENT_QUERY } from '../../checkoutRoutes';
import { useTrackBillingPayOrderCheckoutFinish } from '../../hooks';
import { useAssertStore } from '../../hooks/useAssertStore';
import {
  trackingBillingViewCheckoutCharges,
  trackingBillingViewCheckoutChargesAfterPayment,
} from '../../tracking';

function PlansAndSubscriptions(): JSX.Element {
  const t = useTranslationBilling();
  const hideAdBars = useQuery().get('hideAdBars') === 'true';
  const { hideTopAdBar, showTopAdBar } = useTopAdBar();
  const { hasSearchParam, goBack } = useNavegate();
  const { isShowMenu } = useTopBar();
  const { isShowMenu: isShowAsideMenu } = useDesktopMenuContext();
  const backNavigation = {
    onClick: goBack,
    children:
      !isShowMenu && !isShowAsideMenu ? t('billingPlansPage.back') : undefined,
  };
  const fromPayment = hasSearchParam(FROM_PAYMENT_QUERY);

  useAssertStore();

  useEffect(() => {
    if (fromPayment) {
      trackingBillingViewCheckoutChargesAfterPayment();
    } else {
      trackingBillingViewCheckoutCharges();
    }
  }, [fromPayment]);

  useTrackBillingPayOrderCheckoutFinish();

  const { canReactivateWithoutPayment } = useStoreChurnedStatus();

  useEffect(() => {
    if (hideAdBars) hideTopAdBar();
    return () => {
      showTopAdBar();
    };
  }, [hideAdBars, hideTopAdBar, showTopAdBar]);

  if (canReactivateWithoutPayment) {
    return <CanceledStorePage />;
  }

  return (
    <IonPageStratus
      headerTop={<HeaderTop navigation={backNavigation} />}
      headerContent={
        <HeaderContent
          title={t('checkout.plansAndSubscriptions.title')}
          subtitle={t('checkout.plansAndSubscriptions.subTitle')}
        />
      }
      width="medium"
    >
      {!hideAdBars && <FirstPaymentModal />}

      <PlansAndSubscriptionsV2 />

      <HelpLink
        linkURL={t('checkout.plansAndSubscriptions.helpLink.url')}
        previousValue="checkout_charges"
        title={t('checkout.plansAndSubscriptions.helpLink.text')}
        currentViewTracking={t(
          'checkout.plansAndSubscriptions.helpLink.amplitudeName',
        )}
        icon="both"
      />
    </IonPageStratus>
  );
}

export default PlansAndSubscriptions;
